module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst cssClasses = ['tabCollection'];\nif(config.flexHeight){\ncssClasses.push('flexHeight');\n}\nif(config.maxWidthTabs){\ncssClasses.push('maxWidthTabs');\n}\nif(config.invertedColors){\ncssClasses.push('invertedColors');\n}\n%><div class=\"<%= cssClasses.join(' ') %>\"><%\nif(config.addRelationshipElementButtonsFormMapping){\n%><%- include('../form/elements/buttons', { formMapping: config.addRelationshipElementButtonsFormMapping }) %><%\n}\n%><section class=\"tabs\">\n<%\nif(config.isMainNav){\n%><section class=\"mainTabs\"></section><%\n}\n%>\n<section class=\"subTabContainer\">\n<%\nif(config.isMainNav){\n%><%- include('./mainTabAlias', { model: model.mainTabAliasData || {} }) %><%\n}\n%>\n<section class=\"subTabsWrapper\">\n<section class=\"subTabs\">\n<%- helpers.renderSection('tabs', false); %>\n</section>\n</section>\n<%\n%><%- include('./alternativeTabSelector', {}) %><%\n%>\n</section>\n</section>\n<%- helpers.renderSection('tabContents', true, true); %>\n</div>"
  , __filename = "components/templates/core/tabStrip/tabStrip.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const cssClasses = ['tabCollection'];
if(config.flexHeight){
cssClasses.push('flexHeight');
}
if(config.maxWidthTabs){
cssClasses.push('maxWidthTabs');
}
if(config.invertedColors){
cssClasses.push('invertedColors');
}

    ; __line = 12
    ; __append("<div class=\"")
    ; __append(escapeFn( cssClasses.join(' ') ))
    ; __append("\">")
    ; 
if(config.addRelationshipElementButtonsFormMapping){

    ; __line = 14
    ; __append( include('../form/elements/buttons', { formMapping: config.addRelationshipElementButtonsFormMapping }) )
    ; 
}

    ; __line = 16
    ; __append("<section class=\"tabs\">\n")
    ; __line = 17
    ; 
if(config.isMainNav){

    ; __line = 19
    ; __append("<section class=\"mainTabs\"></section>")
    ; 
}

    ; __line = 21
    ; __append("\n<section class=\"subTabContainer\">\n")
    ; __line = 23
    ; 
if(config.isMainNav){

    ; __line = 25
    ; __append( include('./mainTabAlias', { model: model.mainTabAliasData || {} }) )
    ; 
}

    ; __line = 27
    ; __append("\n<section class=\"subTabsWrapper\">\n<section class=\"subTabs\">\n")
    ; __line = 30
    ; __append( helpers.renderSection('tabs', false) )
    ; __append("\n</section>\n</section>\n")
    ; __line = 33
    ; 

    ; __line = 34
    ; __append( include('./alternativeTabSelector', {}) )
    ; 

    ; __line = 35
    ; __append("\n</section>\n</section>\n")
    ; __line = 38
    ; __append( helpers.renderSection('tabContents', true, true) )
    ; __append("\n</div>")
    ; __line = 39
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/tabStrip/tabStrip.ejs

}